import { render } from "./updateEmail.vue?vue&type=template&id=7c8b0c76&scoped=true"
import script from "./updateEmail.vue?vue&type=script&lang=js"
export * from "./updateEmail.vue?vue&type=script&lang=js"

import "./updateEmail.vue?vue&type=style&index=0&id=7c8b0c76&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c8b0c76"]])

export default __exports__